import {UnitsState} from './state/units.state';

export const unitsStates = [
    UnitsState
];
